// extracted by mini-css-extract-plugin
export default {"modal":"_26s4Y","root":"_3rUoX","footer":"_3kHXl"};